var map = {
	"./confusion.png": 332,
	"./dishonesty.jpg": 376,
	"./hero.jpg": 662,
	"./history.jpg": 228,
	"./leader.jpg": 645,
	"./oppression.jpg": 342,
	"./quran.jpg": 177,
	"./tribal.jpg": 806,
	"./vision.jpg": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;